import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropType from 'prop-types';
import '../onboarding.sass';

export class Tianjin22987112 extends PureComponent {
  render() {
    const { t } = this.props;
    return (
      <div className="onboarding">
        <div className="head" style={{ backgroundImage: 'url(/images/frontpage/suunto/onboarding/tianjin/2.29.8.7112/bg_head.jpg)', padding: '10% 8% 12%' }}>
          <div>{t('TXT_NEW_VERSION')}</div>
          <div>{t('TXT_INTRODUCTION')}</div>
          <p>{t('TXT_NEW_VERSION_EXPLANATION')}</p>
        </div>

        {/* AMOLED screen */}
        <img src="/images/frontpage/suunto/onboarding/tianjin/2.29.8.7112/screen.png" alt="AMOLED screen" style={{ width: '78%', margin: '4em auto 3em', display: 'block' }} />
        <div className="explanation">
          <h3>{t('TXT_AMOLED_SCREEN')}</h3>
          <p>{t('TXT_AMOLED_SCREEN_EXPLANATION')}</p>
        </div>

        {/* Create routes */}
        <img src="/images/frontpage/suunto/onboarding/tianjin/2.29.8.7112/routes.png" alt="Create routes" />
        <div className="explanation">
          <h3>{t('TXT_CREATE_ROUTES')}</h3>
          <p>{t('TXT_CREATE_EXPLANATION')}</p>
        </div>

        {/* Keep watch and phone connected */}
        <img src="/images/frontpage/suunto/onboarding/tianjin/2.29.8.7112/connected.png" alt="Keep watch and phone connected" />
        <div className="explanation">
          <h3>{t('TXT_PHONE_CONNECTED')}</h3>
          <p>{t('TXT_PHONE_CONNECTED_EXPLANATION')}</p>
        </div>

        {/* Custom training modes */}
        <img src="/images/frontpage/suunto/onboarding/tianjin/2.29.8.7112/modes.png" alt="Custom training modes" />
        <div className="explanation">
          <h3>{t('TXT_CUSTOM_TRAINING_MODDS')}</h3>
          <p>{t('TXT_CUSTOM_TRAINING_EXPLANATION')}</p>
        </div>

        <div className="foot">
          <div className="tit">{t('TXT_ADVENTURE_START')}</div>
          <a href="https://www.suunto.com">Suunto.com &gt;</a>
        </div>
      </div>
    );
  }
}

Tianjin22987112.defaultProps = {
  t: (str) => str,
};

Tianjin22987112.propTypes = {
  t: PropType.func,
};

export default translate()(Tianjin22987112);
